import { render } from "./Customfields.vue?vue&type=template&id=7b457479&scoped=true"
import script from "./Customfields.vue?vue&type=script&lang=js"
export * from "./Customfields.vue?vue&type=script&lang=js"

import "./Customfields.vue?vue&type=style&index=0&id=7b457479&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b457479"]])

export default __exports__